module.exports = __webpack_public_path__ + "static/media/mail-to-black.efedbf16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/mail-to-black.svg
// module id = 222
// module chunks = 0